// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"d9442ffa","373":"a4c5d9af","582":"4b6a2038","594":"76aa3f90","619":"fc58f7dd","767":"3fdcebca"}[chunkId] + ".chunk.js";
};